import {
  annotationHex,
  annotationInCrop,
  annotationStroke,
  arrowGeometry,
  type Annotation,
  type Box,
} from '@nolens/domain';

/** Desenha as anotações num canvas com o recorte já aplicado (exportações). */
export function drawAnnotations(
  ctx: OffscreenCanvasRenderingContext2D | CanvasRenderingContext2D,
  annotations: Annotation[] | undefined,
  crop: Box,
  W: number,
  H: number,
): void {
  if (!annotations?.length) return;
  const sw = annotationStroke(W, H);
  ctx.save();
  ctx.lineCap = 'round';
  ctx.lineJoin = 'round';
  for (const raw of annotations) {
    const a = annotationInCrop(raw, crop);
    const color = annotationHex(a);
    for (const pass of ['halo', 'color'] as const) {
      const halo = pass === 'halo';
      ctx.strokeStyle = halo ? 'rgba(255,255,255,.75)' : color;
      ctx.fillStyle = halo ? 'rgba(255,255,255,.75)' : color;
      ctx.lineWidth = halo ? sw + 3 : sw;
      if (a.kind === 'box') {
        ctx.beginPath();
        ctx.roundRect(a.x * W, a.y * H, a.w * W, a.h * H, sw * 1.5);
        if (!halo) {
          ctx.globalAlpha = 0.08;
          ctx.fill();
          ctx.globalAlpha = 1;
        }
        ctx.stroke();
        continue;
      }
      const from = { x: a.from.x * W, y: a.from.y * H };
      const g = arrowGeometry(from, { x: a.to.x * W, y: a.to.y * H }, sw);
      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(g.shaftEnd.x, g.shaftEnd.y);
      ctx.stroke();
      ctx.beginPath();
      ctx.moveTo(g.head[0].x, g.head[0].y);
      ctx.lineTo(g.head[1].x, g.head[1].y);
      ctx.lineTo(g.head[2].x, g.head[2].y);
      ctx.closePath();
      ctx.fill();
      if (halo) {
        ctx.lineWidth = 3;
        ctx.stroke();
      }
    }
  }
  ctx.restore();
}
